<template>
  <div class="relative">
    <!-- Botón de notificaciones -->
    <button @click="toggleDropdown" class="relative p-2 rounded-full text-gray-600 hover:text-blue-600 hover:bg-gray-50 transition-colors" title="Notificaciones">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
      </svg>
      <!-- Badge con contador -->
      <span v-if="historialFiltrado.length > 0" class="absolute top-1 right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white text-xs font-bold">
        {{ historialFiltrado.length > 9 ? '9+' : historialFiltrado.length }}
      </span>
    </button>

    <!-- Overlay para móvil -->
    <div v-if="isOpen" class="fixed inset-0 bg-black bg-opacity-50 z-[60] lg:hidden" @click="closeDropdown"></div>

    <!-- Dropdown de notificaciones -->
    <div v-show="isOpen" class="fixed lg:absolute top-20 lg:top-full right-4 lg:right-0 left-4 lg:left-auto mt-0 lg:mt-2 w-auto lg:w-96 bg-white rounded-lg shadow-xl border border-gray-200 z-[70] max-h-[80vh] lg:max-h-96 overflow-hidden flex flex-col">
      <!-- Header -->
      <div class="px-4 py-3 border-b border-gray-200 bg-gray-50">
        <div class="flex items-center justify-between">
          <h3 class="text-sm font-semibold text-gray-700">Mi Actividad</h3>
          <button @click="closeDropdown" class="text-gray-400 hover:text-gray-600">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Loading state -->
      <div v-if="loading" class="flex items-center justify-center py-8">
        <svg class="animate-spin h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>

      <!-- Lista de notificaciones -->
      <div v-else-if="historialFiltrado.length > 0" class="overflow-y-auto flex-1">
        <div v-for="item in historialFiltrado" :key="item.id" class="px-3 sm:px-4 py-3 border-b border-gray-100 hover:bg-gray-50 transition-colors">
          <div class="flex items-start space-x-2 sm:space-x-3">
            <!-- Icono según tipo de acción -->
            <div class="flex-shrink-0 mt-1">
              <div :class="[
                'w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center',
                getActionColor(item.accion_realizada)
              ]">
                <svg class="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="getActionIcon(item.accion_realizada)"></path>
                </svg>
              </div>
            </div>

            <!-- Contenido -->
            <div class="flex-1 min-w-0">
              <!-- Título de la acción -->
              <p class="text-xs font-semibold text-gray-600 mb-1 truncate">
                {{ item.accion_realizada }}
              </p>

              <!-- Detalles de la acción -->
              <p class="text-xs sm:text-sm text-gray-800 leading-snug break-words">
                {{ item.detalles || 'Sin detalles disponibles' }}
              </p>

              <!-- Fecha -->
              <p class="text-xs text-gray-500 mt-1">
                {{ formatearFecha(item.fecha_accion) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Estado vacío -->
      <div v-else class="px-4 py-8 text-center">
        <svg class="w-12 h-12 mx-auto text-gray-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
        </svg>
        <p class="text-sm font-medium text-gray-900 mb-1">Sin actividad reciente</p>
        <p class="text-xs text-gray-500">No hay acciones en los últimos 3 días</p>
      </div>

      <!-- Footer con paginación si hay más -->
      <div v-if="hasMore" class="px-4 py-2 bg-gray-50 border-t border-gray-200">
        <button @click="cargarMas" :disabled="loadingMore" class="w-full text-sm text-blue-600 hover:text-blue-800 font-medium disabled:opacity-50">
          {{ loadingMore ? 'Cargando...' : 'Ver más' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import HistorialService from '@/services/usuarios/historial.js'

export default {
  name: 'NotificacionesDropdown',
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      loading: false,
      loadingMore: false,
      historial: [],
      currentPage: 1,
      hasMore: false,
      totalCount: 0,
      refreshInterval: null
    }
  },
  computed: {
    historialFiltrado() {
      const tresDiasAtras = new Date()
      tresDiasAtras.setDate(tresDiasAtras.getDate() - 3)
      tresDiasAtras.setHours(0, 0, 0, 0)

      return this.historial.filter(item => {
        const fechaItem = new Date(item.fecha_accion)
        return fechaItem >= tresDiasAtras
      })
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal && this.historial.length === 0) {
        this.cargarHistorial()
      }
    }
  },
  mounted() {
    this.cargarHistorial()

    // Auto-refresh cada 60 segundos
    this.refreshInterval = setInterval(() => {
      if (!this.isOpen) {
        this.cargarHistorial()
      }
    }, 60000)

    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown(event) {
      event.stopPropagation()
      this.isOpen = !this.isOpen
    },

    closeDropdown() {
      this.isOpen = false
    },

    handleClickOutside(event) {
      if (this.$el && !this.$el.contains(event.target)) {
        this.closeDropdown()
      }
    },

    async cargarHistorial() {
      if (!this.userId) return

      this.loading = true
      try {
        const response = await HistorialService.getHistorialUsuario(this.userId, 1)

        this.historial = response.results || []
        this.totalCount = response.count || 0
        this.hasMore = !!response.next
        this.currentPage = 1

      } catch (error) {
        console.error('Error cargando historial:', error)
        this.historial = []
      } finally {
        this.loading = false
      }
    },

    async cargarMas() {
      if (!this.userId || this.loadingMore) return

      this.loadingMore = true
      try {
        const nextPage = this.currentPage + 1
        const response = await HistorialService.getHistorialUsuario(this.userId, nextPage)

        this.historial.push(...(response.results || []))
        this.hasMore = !!response.next
        this.currentPage = nextPage

      } catch (error) {
        console.error('Error cargando más historial:', error)
      } finally {
        this.loadingMore = false
      }
    },

    formatearFecha(fechaStr) {
      try {
        const fecha = new Date(fechaStr)
        const ahora = new Date()
        const diffMs = ahora - fecha
        const diffMins = Math.floor(diffMs / 60000)
        const diffHours = Math.floor(diffMs / 3600000)
        const diffDays = Math.floor(diffMs / 86400000)

        if (diffMins < 1) return 'Hace un momento'
        if (diffMins < 60) return `Hace ${diffMins} min`
        if (diffHours < 24) return `Hace ${diffHours}h`
        if (diffDays < 7) return `Hace ${diffDays}d`

        return fecha.toLocaleDateString('es-CL', {
          day: '2-digit',
          month: 'short',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch {
        return fechaStr
      }
    },

    getActionColor(accion) {
      const colorMap = {
        'EDITAR_DISPOSITIVO': 'bg-blue-500',
        'CREAR_DISPOSITIVO': 'bg-green-500',
        'ELIMINAR_DISPOSITIVO': 'bg-red-500',
        'EDITAR_USUARIO': 'bg-yellow-500',
        'CREAR_USUARIO': 'bg-green-500',
        'ELIMINAR_USUARIO': 'bg-red-500',
        'LOGIN': 'bg-purple-500',
        'LOGOUT': 'bg-gray-500'
      }
      return colorMap[accion] || 'bg-gray-400'
    },

    getActionIcon(accion) {
      const iconMap = {
        'EDITAR_DISPOSITIVO': 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
        'CREAR_DISPOSITIVO': 'M12 4v16m8-8H4',
        'ELIMINAR_DISPOSITIVO': 'M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16',
        'EDITAR_USUARIO': 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
        'CREAR_USUARIO': 'M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z',
        'ELIMINAR_USUARIO': 'M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6z',
        'LOGIN': 'M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1',
        'LOGOUT': 'M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1'
      }
      return iconMap[accion] || 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
    }
  }
}
</script>

<style scoped>
.overflow-y-auto::-webkit-scrollbar {
  width: 4px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>